/** How many product ids a wishlist keeps, newest kept; the server reads no more. */
export const WISHLIST_MAX = 200;

/** Longest id either side accepts; a product id is a cuid. */
export const WISHLIST_ID_MAX = 64;
